export enum FlashMessages {
  AccountDeleted = 'flash.account-deleted',
  AddNameSuccess = 'flash.add-name',
  AlreadyClaimed = 'flash.already-claimed',
  CertClaimSuccess = 'flash.cert-claim-success',
  CertificateMissing = 'flash.certificate-missing',
  CertsPrivate = 'flash.certs-private',
  ChallengeSaveTooBig = 'flash.challenge-save-too-big',
  ChallengeSubmitTooBig = 'flash.challenge-submit-too-big',
  CodeSaved = 'flash.code-saved',
  CodeSaveError = 'flash.code-save-error',
  CodeSaveLess = 'flash.code-save-less',
  CompleteProjectFirst = 'flash.complete-project-first',
  DeleteTokenErr = 'flash.delete-token-err',
  EmailValid = 'flash.email-valid',
  GenerateExamError = 'flash.generate-exam-error',
  HonestFirst = 'flash.honest-first',
  IncompleteSteps = 'flash.incomplete-steps',
  LocalCodeSaved = 'flash.local-code-saved',
  LocalCodeSaveError = 'flash.local-code-save-error',
  MsTranscriptErr1 = 'flash.ms.transcript.link-err-1',
  MsTranscriptErr2 = 'flash.ms.transcript.link-err-2',
  MsTranscriptErr3 = 'flash.ms.transcript.link-err-3',
  MsTranscriptErr4 = 'flash.ms.transcript.link-err-4',
  MsTranscriptErr5 = 'flash.ms.transcript.link-err-5',
  MsTranscriptErr6 = 'flash.ms.transcript.link-err-6',
  MsTranscriptLinked = 'flash.ms.transcript.linked',
  MsTranscriptUnlinked = 'flash.ms.transcript.unlinked',
  MsTranscriptUnlinkErr = 'flash.ms.transcript.unlink-err',
  MsProfileErr = 'flash.ms.profile.err',
  MsTrophyErr1 = 'flash.ms.trophy.err-1',
  MsTrophyErr2 = 'flash.ms.trophy.err-2',
  MsTrophyErr3 = 'flash.ms.trophy.err-3',
  MsTrophyErr4 = 'flash.ms.trophy.err-4',
  MsTrophyErr5 = 'flash.ms.trophy.err-5',
  MsTrophyErr6 = 'flash.ms.trophy.err-6',
  MsTrophyVerified = 'flash.ms.trophy.verified',
  NameNeeded = 'flash.name-needed',
  None = '',
  NotEligible = 'flash.not-eligible',
  NotHonest = 'flash.not-honest',
  GenericError = 'flash.generic-error',
  ProfilePrivate = 'flash.profile-private',
  ProgressReset = 'flash.progress-reset',
  ProvideUsername = 'flash.provide-username',
  ReallyWeird = 'flash.really-weird',
  ReportSent = 'flash.report-sent',
  SigninSuccess = 'flash.signin-success',
  StartProjectErr = 'flash.start-project-err',
  SurveyErr1 = 'flash.survey.err-1',
  SurveyErr2 = 'flash.survey.err-2',
  SurveyErr3 = 'flash.survey.err-3',
  SurveySuccess = 'flash.survey.success',
  TimelinePrivate = 'flash.timeline-private',
  TokenDeleted = 'flash.token-deleted',
  UpdatedAboutMe = 'flash.updated-about-me',
  UpdatedSocials = 'flash.updated-socials',
  UpdatedSound = 'flash.updated-sound',
  UpdatedThemes = 'flash.updated-themes',
  UpdatedKeyboardShortCuts = 'flash.keyboard-shortcut-updated',
  UpdatedQunicyEmailSubscription = 'flash.subscribe-to-quincy-updated',
  UpdatedPortfolio = 'flash.portfolio-item-updated',
  UpdatedPrivacy = 'flash.privacy-updated',
  UsernameNotFound = 'flash.username-not-found',
  UsernameTaken = 'flash.username-taken',
  UsernameUpdated = 'flash.username-updated',
  UsernameUsed = 'flash.username-used',
  UserNotCertified = 'flash.user-not-certified',
  WrongName = 'flash.wrong-name',
  WrongUpdating = 'flash.wrong-updating',
  WentWrong = 'flash.went-wrong'
}
